
const freeShippingCap = 200;

export {
  freeShippingCap,
};



// WEBPACK FOOTER //
// ./src/modules/local-values/utils/benefits.js